import Header from "../modules/layout/Header";

function ExamStartInfo() {
    return (
        <div>
            <Header />
            <div className="base-sec" style={{ position: "relative" }}>
                <div className="background-color-w">
                    <div className="base-sec-top flex">
                        <div>
                            <p className="title">영어 말하기 평가</p>
                        </div>
                    </div>
                    <div className="base-sec-sec complete-sec text-align-center">
                        <div className="page-title text-align-center">
                            <p>실전 시험</p>
                        </div>
                        <div className="svg-test"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExamStartInfo;